/**
 * Schadensklassifizierung component.
 * @module components/views/Schadensklassifizierung/Schadensklassifizierung
 */

import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { isEqual } from "lodash";

import { getSchadensklassifizierung } from "../../../actions/schadensklassifizierung/schadensklassifizierung";

import Chart from "../../charts/Chart/Chart";
import Map from "../../elements/Map/Map";

import { diagramsViews } from "../../../constants/Dashboards";
import * as charts from "../../../constants/Charts";

import { VIEW_SCHADENSKLASSIFIZIERUNG } from "../../../constants/NamesViews";
import InOutCarat from "../../elements/InOutCarat/InOutCarat";
/**
 * Schadensklassifizierung component class.
 * @class Schadensklassifizierung
 * @extends Component
 */
class Schadensklassifizierung extends Component {
  /**
   * Component did mount
   * @method componentDidMount
   * @returns {undefined}
   */
  componentDidMount() {
    this.props.getSchadensklassifizierung(
      this.props.project,
      this.props.bucket,
      this.props.filtersApplied,
      this.props.scales,
      this.props.units,
      this.props.typeDashboard
    );
  }

  /**
   * Component will receive props
   * @method UNSAFE_componentWillReceiveProps
   * @param {Object} nextProps Next properties
   * @returns {undefined}
//   */
  //  UNSAFE_componentWillReceiveProps(nextProps) {
  //    if (
  //      !isEqual(this.props.filtersApplied, nextProps.filtersApplied) ||
  //      !isEqual(this.props.scales, nextProps.scales) ||
  //      !isEqual(this.props.units, nextProps.units) ||
  //      !isEqual(this.props.bucket, nextProps.bucket) ||
  //      !isEqual(this.props.project, nextProps.project)
  //    ) {
  //      this.props.getSchadensklassifizierung(
  //        nextProps.project,
  //        nextProps.bucket,
  //        nextProps.filtersApplied,
  //        nextProps.scales,
  //        nextProps.units,
  //        nextProps.typeDashboard
  //      );
  //    }
  //  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !isEqual(prevProps.filtersApplied, this.props.filtersApplied) ||
      !isEqual(prevProps.scales, this.props.scales) ||
      !isEqual(prevProps.units, this.props.units) ||
      !isEqual(prevProps.bucket, this.props.bucket) ||
      !isEqual(prevProps.project, this.props.project)
    ) {
      prevProps.getSchadensklassifizierung(
        this.props.project,
        this.props.bucket,
        this.props.filtersApplied,
        this.props.scales,
        this.props.units,
        this.props.typeDashboard
      );
    }
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    const {
      schadensklassifizierung,
      typeDashboard,
      mapMaximized,
      mapMinimized,
    } = this.props;

    let height = "50%";
    if (mapMaximized) {
      height = "0%";
    } else if (mapMinimized) {
      height = "100%";
    }

    return (
      <div className="mapWrapper">
        <div className="mapDetail" style={{ height: height }}>
          <Container className="containerDiagrams inner">
            <Row>
              <Chart
                data={
                  schadensklassifizierung[charts.SCHADENSKLASSE_STANDSICHERHEIT]
                }
                id={charts.SCHADENSKLASSE_STANDSICHERHEIT}
                typeView={VIEW_SCHADENSKLASSIFIZIERUNG}
              />
              <Chart
                data={schadensklassifizierung[charts.SCHADENSKLASSE_BETRIEB]}
                id={charts.SCHADENSKLASSE_BETRIEB}
                typeView={VIEW_SCHADENSKLASSIFIZIERUNG}
              />
              <Chart
                data={schadensklassifizierung[charts.SCHADENSKLASSE_DICHTHEIT]}
                id={charts.SCHADENSKLASSE_DICHTHEIT}
                typeView={VIEW_SCHADENSKLASSIFIZIERUNG}
              />
              <Chart
                data={schadensklassifizierung[charts.SCHADENSART]}
                id={charts.SCHADENSART}
                typeView={VIEW_SCHADENSKLASSIFIZIERUNG}
              />
            </Row>
          </Container>
        </div>
        <InOutCarat />
        <Map view="schadensklassifizierung" typeDashboard={typeDashboard} />
      </div>
    );
  }
}

export default connect(
  (state, props) => {
    const diagrams = diagramsViews[VIEW_SCHADENSKLASSIFIZIERUNG];
    const units = Object.keys(diagrams).reduce((collector, key) => {
      collector[key] = state.chartSettings.unit[key];
      return collector;
    }, {});
    const scales = Object.keys(diagrams).reduce((collector, key) => {
      collector[key] = state.chartSettings.scale[key];
      return collector;
    }, {});

    return {
      schadensklassifizierung: state.schadensklassifizierung.data,
      filtersApplied: state.filters.filtersApplied,
      reload: state.filters.reload || state.chartSettings.dirty,
      project: state.projects.project,
      bucket: state.projects.bucket,
      units: units,
      scales: scales,
      mapMaximized: props.alwaysMaximized || state.map.mapDashboardsMaximized,
      mapMinimized: props.alwaysMinimized || state.map.mapDashboardsMinimized,
    };
  },
  { getSchadensklassifizierung }
)(Schadensklassifizierung);
